import { ChartLineIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Reports = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChartLineIcon size={Sizes[size]} {...rest} color={fill} />;
};

Reports.displayName = 'Reports';
